import { render, staticRenderFns } from "./DeleteRoute.vue?vue&type=template&id=b414253c&"
import script from "./DeleteRoute.vue?vue&type=script&lang=js&"
export * from "./DeleteRoute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports